import { render, staticRenderFns } from "./crm_header.vue?vue&type=template&id=6372e9f4&scoped=true&"
import script from "./crm_header.vue?vue&type=script&lang=js&"
export * from "./crm_header.vue?vue&type=script&lang=js&"
import style0 from "./crm_header.vue?vue&type=style&index=0&id=6372e9f4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6372e9f4",
  null
  
)

export default component.exports